import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import Alpine from 'alpinejs';
import Tooltip from './components/alpine/Tooltip';
import Modal from './components/alpine/Modal';
import SameHeightContainer from './components/alpine/SameHeightContainer';
import SubMenue from './components/alpine/SubMenue';
import PopIn from './components/alpine/PopIn';
import Track from './components/alpine/magics/Track';
import SendForm from './components/alpine/SendForm';
import TrackRead from './components/alpine/TrackRead';
import ContentNativeAdvertising from './components/alpine/ContentNativeAdvertising';
import './lib/freemius-checkout.min.js';
import AOS from 'aos';
import '../../node_modules/aos/src/sass/aos.scss';

import Prism from 'prismjs';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-bash';
Prism.highlightAll();

import FreemiusCheckout from './components/FreemiusCheckout';
window.fr_checkout = FreemiusCheckout;
window.ilj_fsc = { licenses: 1, billing_cycle: 'annual' };

window.Alpine = Alpine

document.addEventListener('alpine:init', () => {
  Alpine.data('tooltip', Tooltip);
  Alpine.data('modal', Modal);
  Alpine.data('sameHeightContainer', SameHeightContainer);
  Alpine.data('subMenue', SubMenue);
  Alpine.data('popIn', PopIn);
  Alpine.data('sendForm', SendForm);
  Alpine.data('trackRead', TrackRead);
  Alpine.data('coNaAd', ContentNativeAdvertising);

  Alpine.magic('track', Track);
});

import { listen } from 'quicklink';
const quicklink = { listen: listen };

document.addEventListener("DOMContentLoaded", function () {
  Alpine.start();
  quicklink.listen();

  //Instantiate splide:
  var elms = document.getElementsByClassName('Testimonials');

  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '1.5rem',
      classes: {
        // Add classes for arrows.
        arrows: 'Testimonials__arrows',
        arrow: 'Testimonials__arrow',
        prev: 'splide__arrow--prev Testimonials__prev',
        next: 'splide__arrow--next Testimonials__next',

        // Add classes for pagination.
        pagination: 'splide__pagination your-class-pagination', // container
        page: 'splide__pagination__page your-class-page', // each button
      },
      pagination: false,
      breakpoints: {
        768: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        }
      }
    }).mount();
  }

  //Instantiate splide:
  var elms = document.getElementsByClassName('RelatedPosts');

  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      type: 'loop',
      perPage: 2,
      perMove: 1,
      gap: '1.5rem',
      classes: {
        // Add classes for arrows.
        arrows: 'RelatedPosts__arrows',
        arrow: 'RelatedPosts__arrow',
        prev: 'splide__arrow--prev RelatedPosts__prev',
        next: 'splide__arrow--next RelatedPosts__next',

        // Add classes for pagination.
        pagination: 'splide__pagination', // container
        page: 'splide__pagination__page', // each button
      },
      pagination: false,
      breakpoints: {
        640: {
          perPage: 1,
        }
      }
    }).mount();
  }
});

AOS.init(
  {
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'load', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    // offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 300, //200, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: true, // whether elements should animate out while scrolling past them
  }
);